import { render } from "./DeveloprViewComponent.vue?vue&type=template&id=7a742283"
import script from "./DeveloprViewComponent.vue?vue&type=script&lang=js"
export * from "./DeveloprViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__